/**
 * Running Reload: faster reloads, but only while moving.
 *
 * The seed instance for a conditional lever, and the perk the issue names first. It is worth
 * nothing to somebody holding an angle and worth a great deal to somebody backing out of a room,
 * which is the difference between a perk and a percentage.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const RUNNING_RELOAD = {
  id: 'runningReload',
  branch: 'gunplay',
  tier: 2,
  title: 'Running Reload',
  blurb: 'Halcyon policy permits reloading in transit. Halcyon policy is not liability.',
  maxRanks: 3,
  minLevel: 7,
  requires: ['steadyHands'],
  statGrants: {},
  effects: [{ field: 'reloadSeconds', perRank: -0.08, condition: 'whileMoving' }],
  damageModifiers: [],
} as const satisfies Perk;
